export default "__VITE_ASSET__BG9_3D2A__"